import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { RoutesService } from "@rubbl-layout";
import { BaseCapabilityLayout } from "../../manage-shared/base-capability-layout.component";

@Component({
  selector: "app-renter-layout",
  templateUrl: "./renter-layout.component.html",
  styleUrls: ["./renter-layout.component.scss"],
})
export class RenterLayoutComponent extends BaseCapabilityLayout {
  constructor(router: Router, activatedRoute: ActivatedRoute, public routesService: RoutesService) {
    super(router, activatedRoute);
  }
}
